import { createI18n } from 'vue-i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'
const messages = {
  sv,
  en
}
const i18n = createI18n({
  legacy: false,
  locale: window.appConfig.VITE_I18N_LOCALE || 'en',
  fallbackLocale: window.appConfig.VITE_I18N_FALLBACK_LOCALE || 'en',
  messages
})

export default i18n
